import { ClaimsActivityLineOfBusinessTypeEnum } from "@app/projects/network-assessment/pci-dashboard/claims-activity";
import { BenchmarkingLineOfBusinessEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared/BenchmarkingLineOfBusinessEnum";

function getPcaLineOfBusiness(selectedLineOfBusiness: BenchmarkingLineOfBusinessEnum): ClaimsActivityLineOfBusinessTypeEnum {
  switch (selectedLineOfBusiness) {
    case BenchmarkingLineOfBusinessEnum.Medicare:
      return ClaimsActivityLineOfBusinessTypeEnum.Medicare;
    case BenchmarkingLineOfBusinessEnum.Marketplace:
      return ClaimsActivityLineOfBusinessTypeEnum.Commercial;
    case BenchmarkingLineOfBusinessEnum.Medicaid:
      return ClaimsActivityLineOfBusinessTypeEnum.Medicaid;
    default:
      return ClaimsActivityLineOfBusinessTypeEnum.Medicare;
  }
}

export { getPcaLineOfBusiness };